export default __webpack_public_path__ + "static/media/sample_manager.ee6f9d70.xlsx";